export const SILENT_NOTIFICATION_TYPE = 'test-org-ack';
